var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-section.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { css } from "@adornis/chemistry/directives/css";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes";
import "@adornis/chemistry/elements/components/x-flex";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
var GeSection = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({ ":host": { width: "100%", display: "block" } });
  }
  render() {
    return html`
      <x-flex
        ${css({
      padding: `0 ${this.spacing.md}`,
      margin: "auto",
      width: "100%",
      height: "100%",
      maxWidth: this.sizes.maxPageWidth
    })}
        ${injectAttributesOf(this)}
      >
        <slot></slot>
      </x-flex>
    `;
  }
};
GeSection = __decorateClass([
  customElement("ge-section")
], GeSection);
export {
  GeSection
};
